import {
	getBoolean,
	getNumber,
	getString,
} from "../../../../../utils/mappersUtils/object";
import { isObject } from "../../../../../utils/mappersUtils/guards";

export const mapMessageTemplateId = (template) => {
	if (!isObject(template)) {
		return null;
	}

	return {
		id: getNumber(template, "id"),
	}
}

export const mapMessageTemplate = (template) => {
	if (!isObject(template)) {
		return null;
	}

	return {
		id: getNumber(template, "id"),
		language: getString(template, "language"),
		country: {
			id: getNumber(template, "country.id", null),
			description: getString(template, "country.description", null),
		},
		brand: {
			id: getNumber(template, "brand.id", null),
			description: getString(template, "brand.description", null),
		},
		outletId: getNumber(template, "outletId", null),
		useCase: {
			id: getNumber(template, "useCase.id"),
			description: getString(template, "useCase.description"),
			messageType: getNumber(template, "useCase.messageType"),
		},
		isWaitsOnPremiseDependent: getBoolean(template, "isWaitsOnPremiseDependent", false),
		isWaitsOnPremise: getBoolean(template, "isWaitsOnPremise", false),
	};
};

export const mapMessageTemplates = (templates) => {
	if (!Array.isArray(templates)) {
		return [];
	}

	return templates
		.map((template) => mapMessageTemplate(template))
		.filter((template) => template !== null);
};
